export enum EventType {
  SOPRALLUOGO = 1,
  VISITA_IMMOBILE = 2,
  CALL = 3,
  VIDEO_CALL = 4,
  GESTIONE = 14,
  SMS_WA = 6,
  INCONTRO = 9,
  VALUTAZIONE = 13,
  OPENHOUSE = 20,
  PERMUTA = 23,
  PERSONALE = 17,
}

export enum EventStatus {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Tentative = 'tentative',
}

export enum EventStateEnum {
  ESEGUITO = 1,
  RIPROGRAMMATO = 2,
  ANNULLATO = 3,
  CONTESTATO = 4,
}

export enum DisputeStateEnum {
  DA_LAVORARE = 1,
  IN_VERIFICA = 2,
  DA_RICHIAMARE = 3,
  KO = 4,
  APP_DA_FISSARE = 5,
  APP_FISSATO = 6,
  RICHIAMA_CLIENTE = 7,
}
